module.exports = __webpack_public_path__ + "static/media/sagawa-express.7b74bedb.svg";